import React from 'react'

function HoursText({clinicHours}) {
  return (
    <div>
        <table className="table table-striped">
            <tbody>
                {clinicHours.map((item, index) => (
                    <tr key={index}>
                        <td className='ps-3'>{item.day}</td>
                       
                        <td>
                            <div className="d-flex flex-column">
                                <span>{item.start} - {item.end}</span>
                                <span>{item.note}</span>
                            </div>
                        </td>
                        <td>
                            {item.status === 1?<span><i class="bi bi-check2-circle"></i></span> : <span><i class="bi bi-x-circle"></i></span> }
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
  )
}

export default HoursText